'use strict';
import {getLink} from '../../core-utilities/domain/ReduxUtils';


export function getStatusPermission(status) {
  switch (status) {
    case 'pending':
    case 'in_progress':
    case 'submitted':
      return 'requirement_submission_edit';
    case 'cancelled':
    case 'rejected':
    case 'approved':
      return 'requirement_approval_edit';
    default:
      return null
  }
}

export function getAssetStatusPermission(status) {
  return `asset_${getStatusPermission(status)}`;
}

export function AbstractRequirementProvider() {
  return {
    $get: [
      '$injector',
      'AbstractDomainClass',
      'AuthService',
      'OrgIdMixin',
      'FeedableMixin',
      'restUtils',
      'FirebaseConnectionService',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function (
        $injector,
        AbstractDomainClass,
        AuthService,
        OrgIdMixin,
        FeedableMixin,
        restUtils,
        FirebaseConnectionService,
        FirebaseQueueService,
        ROOT_API_COLLECTION,
        ROOT_API_SPEC,
      ) {

        function AbstractRequirement() {
          //AbstractDomainClass.call(this, Class, data); // args: Class, data
        }

        // TODO: add appropriate update status method and remove legacy code

        AbstractRequirement.__inheritFrom = function (Class, className, collection, config) {
          AbstractDomainClass.__inheritFrom(Class, className, collection, config);
          OrgIdMixin(Class);
          FeedableMixin(Class);

          Class.$constraints.addConstraints({
            name: {type: 'string'},
            description: {type: 'string', widget: 'textarea', nullable: true},
            status: {
              type: 'string',
              inList: ['pending', 'cancelled', 'in_progress', 'submitted', 'has_rejection', 'rejected', 'approved'],
              defaultValue: 'pending'
            },
            org: {type: 'string'}, // Organization ID
            prj: {type: 'string'}, // Project ID
            createdBy: {type: 'DomainLink', domainClass: 'UserDomain', nullable: true},
            dateCreated: {type: 'Date'},
            lastUpdated: {type: 'Date'},

            conversation: {type: 'LinkedDocument', domainClass: 'ConversationDomain', link: 'target'}
          });

          //Class.prototype << AbstractRequirement.prototype

          Class.getStatusPermission = collection.indexOf('asset') > -1 ? getAssetStatusPermission : getStatusPermission;

          Class.prototype.isValidStatusProgression = AbstractRequirement.prototype.isValidStatusProgression;
          Class.prototype.toString = AbstractRequirement.prototype.toString;

          const updateStatusOptions = {};
          if (config && config.afterUpdateStatusSuccess)
            updateStatusOptions.afterSuccess = config.afterUpdateStatusSuccess;

          const updateStatusImpl = restUtils.updateStatus(Class, updateStatusOptions);
          Class.updateStatus = function updateStatusStatic(instance, status, comment) {
            if (instance.status === status) {
              return Promise.reject({code: 'requirements.status.change.error.samestatus.message', rejectedValue: status});
            } else if (status === 'has_rejection') {
              return Promise.reject({code: 'requirements.status.change.error.invalid.message', rejectedValue: status});
            } else {
              return updateStatusImpl(instance, status, comment);
            }
          };
          Class.prototype.updateStatus = function updateStatusProto(status, comment) {
            return Class.updateStatus(this, status, comment);
          }
        };

        AbstractRequirement.generatePropagateRequirementToAssets = function generatePropagateRequirementToAssets(requirementType) {
          return function propagateRequirementToAssets(requirement) {
            const request = {
              method: 'project/assets/requirements/propagate',
              taskId: getLink(requirement, 'task').id,
              requirementId: requirement.$id,
              requirementType: requirementType
            };

            return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
          }
        };

        //AbstractRequirement.prototype methods go here

        //TODO: convert to consult metrics validStatuses object
        AbstractRequirement.prototype.isValidStatusProgression = function (status) {
          return this.status !== status && status !== 'has_rejection';
        };

        AbstractRequirement.prototype.toString = function () {
          return this.name;
        };

        return AbstractRequirement;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/AbstractRequirement.js